export default "__VITE_ASSET__Brlb0zd___"